import { useVueAuth } from "oidc-vue"
import { onMounted } from "vue"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import Popups from "./components/Popups"
import MainApp from "./MainApp"

const App: ReactiveComponent = () => {
	const auth = useVueAuth()

	onMounted(() => {
		if (!auth.user.value) {
			void auth.manager.signinRedirect()
		}
	})

	return () => (
		<>
			{!!auth.loggedIn.value && <MainApp />}
			<Popups />
		</>
	)
}

export default defineComponent(App)
